export default __webpack_public_path__ + "static/media/profile.97c5be9c.png";